import { useEffect, useState } from "react";
import defoltImage from "../assets/images/default-profile-icon-5.jpg";

export const ImageChecker = ({ profilePhoto }) => {
  const [validPhoto, setValidPhoto] = useState(null);

  useEffect(() => {
    if (profilePhoto) {
      fetch(profilePhoto, { method: "HEAD" })
        .then((res) => {
          if (res.ok) setValidPhoto(profilePhoto);
          else setValidPhoto(defoltImage);
        })
        .catch(() => setValidPhoto(defoltImage));
    }
  }, [profilePhoto]);

  return <img src={validPhoto} alt="Profile" />;
};
